import type { SeasonIdentifiers } from '$lib/types/tradingRewards';

export const currentSeason: SeasonIdentifiers = 'season-2';
